import createVueApp from '@phoenix/createVueApp';
import FocusBlock from '@maison/components/blocks/FocusBlock.vue';

const app = createVueApp();
app.component('FocusBlock', FocusBlock);
app.mount('#focus-block');
